var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdStrengthenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8C6 6.89543 6.89543 6 8 6H11C12.1046 6 13 6.89543 13 8V24C13 25.1046 12.1046 26 11 26H8C6.89543 26 6 25.1046 6 24V8ZM11 8H8V24H11V8Z",
    fill: "#333A48"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 8C19 6.89543 19.8954 6 21 6H24C25.1046 6 26 6.89543 26 8V24C26 25.1046 25.1046 26 24 26H21C19.8954 26 19 25.1046 19 24V8ZM24 8H21V24H24V8Z",
    fill: "#333A48"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 10C24 9.44772 24.4477 9 25 9H28C28.5304 9 29.0391 9.21071 29.4142 9.58579C29.7893 9.96086 30 10.4696 30 11V21C30 21.5304 29.7893 22.0391 29.4142 22.4142C29.0391 22.7893 28.5304 23 28 23H25C24.4477 23 24 22.5523 24 22C24 21.4477 24.4477 21 25 21H28V11H25C24.4477 11 24 10.5523 24 10Z",
    fill: "#333A48"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.58579 9.58579C2.96086 9.21071 3.46957 9 4 9H7C7.55228 9 8 9.44772 8 10C8 10.5523 7.55228 11 7 11H4V21H7C7.55228 21 8 21.4477 8 22C8 22.5523 7.55228 23 7 23H4C3.46957 23 2.96086 22.7893 2.58579 22.4142C2.21071 22.0391 2 21.5304 2 21V11C2 10.4696 2.21071 9.96086 2.58579 9.58579Z",
    fill: "#333A48"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 16C11 15.4477 11.4477 15 12 15H20C20.5523 15 21 15.4477 21 16C21 16.5523 20.5523 17 20 17H12C11.4477 17 11 16.5523 11 16Z",
    fill: "#333A48"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 16C28 15.4477 28.4477 15 29 15H31C31.5523 15 32 15.4477 32 16C32 16.5523 31.5523 17 31 17H29C28.4477 17 28 16.5523 28 16Z",
    fill: "#333A48"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 16C0 15.4477 0.447715 15 1 15H3C3.55228 15 4 15.4477 4 16C4 16.5523 3.55228 17 3 17H1C0.447715 17 0 16.5523 0 16Z",
    fill: "#333A48"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdStrengthenIcon);
export default __webpack_public_path__ + "static/media/ad-strengthen-icon.2cf4852e653207c08b75a5e4b4a26769.svg";
export { ForwardRef as ReactComponent };